import React from "react";
import { Row, Col } from "reactstrap";

const Renderquestions = (props) => {

  const participantFullName =
    props.invitationDetails &&
    props.invitationDetails.user_assessment__participant__full_name;
  const renderTextBasedOnGender = () => {
    if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 1
    ) {
      return (
        <p>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_male
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 2
    ) {
      return (
        <p>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_female
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else if (
      props.assessmentType == "invitations" &&
      props.participant_gender == 3
    ) {
      return (
        <p>
          {`${props.questionList &&
            props.questionList.user_questions.question_statement_others
            }`.replace("#Name", `${participantFullName}`)}
        </p>
      );
    } else {
      return (
        <p>
          {props.questionList &&
            props.questionList.user_questions.question_statement_self}
        </p>
      );
    }
  };
  const fetchHighestNumberedKeyFromValues = () => {
    const valueKeys = Object.keys(props.values).map((number) => {
      return +number;
    });
    if (valueKeys.length) {
      return Math.max(...valueKeys);
    }
    return 0;
  };
  const renderLiElement = (qNumber, i, runningQuestionId) => {
    return (
      <React.Fragment>
        {props.reviewMode === false ? (
          <li
            className={
              props.defaultQuestionNumber === i + 1
                ? "active"
                : fetchHighestNumberedKeyFromValues() + 1 < i + 1
                  ? "disabled"
                  : ""
            }
            key={qNumber.id}
            onClick={() => {
              if (fetchHighestNumberedKeyFromValues() + 1 >= i + 1) {
                props.handleQuestionNumber(qNumber, qNumber.id, i);
              }
            }}
            value={qNumber.id}
          // value={runningQuestionId}
          >
            <div
              className={
                props.defaultQuestionNumber === i + 1
                  ? "dark-arrow"
                  : "right-arrow"
              }
            ></div>
            <div className="back-arrow"></div>
            {i + 1}
          </li>
        ) : (
          <li
            className={props.defaultQuestionNumber === i + 1 ? "active" : ""}
            key={qNumber.id}
            onClick={() => {
              props.handleQuestionNumber(qNumber, qNumber.id, i);
            }}
            value={qNumber.id}
          >
            <div
              className={
                props.defaultQuestionNumber === i + 1
                  ? "dark-arrow"
                  : "right-arrow"
              }
            ></div>
            <div className="back-arrow"></div>
            {i + 1}
          </li>
        )}
      </React.Fragment>
    );
  };
  return (
    <div className="question-wrapper">
      <Row>
        <Col md="1">
          <p className="question-text">Question</p>
        </Col>
        <Col md="11">
          <ul className="number-wrapper" ref={props.myRef} id="number-wrapper">
            {props.questionNumber.map((getQuestionNumber, index) => {
              return (
                <React.Fragment key={index}>
                  {renderLiElement(
                    getQuestionNumber,
                    index,
                    props.runningQuestionId
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </Col>
      </Row>
      <div className="question">
        <div className="q-number">
          <p>
            Q<span>{props.defaultQuestionNumber}.</span>
          </p>
        </div>
        <div className="questionText">{
          props.questionList === null ? "" :
          renderTextBasedOnGender()}</div>
      </div>
    </div>
  );
};
export default Renderquestions;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/question-wrapper.jsx